export default __webpack_public_path__ + "static/media/tag-grey.8f7f3dbe.svg";